import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from "../../../../common/variables/translate-service";
import { GlobalVariableService } from "../../../../common/variables/global-variable";

@Component({
  selector: 'sen-app-generator-tool',
  templateUrl: './generator-tool.component.html',
  styleUrls: ['./generator-tool.component.scss']
})

export class GeneratorToolComponent implements OnInit {
  generatorColor: string;
  constructor(public dialogRef: MatDialogRef<GeneratorToolComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public translate: TranslateService,
    public global: GlobalVariableService
  ) { }

  ngOnInit(): void {
    this.generatorColor = this.data.color;
  }

  closeDialogue() {
    this.dialogRef.close(this.generatorColor);
  }

}
